import * as Sentry from '@sentry/react';
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { AlertCircle, ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function SentryTestPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-950 flex flex-col items-center justify-center p-6 gap-8">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-emerald-500/10 via-transparent to-transparent pointer-events-none" />
      
      <button 
        onClick={() => navigate('/')}
        className="absolute top-8 left-8 flex items-center gap-2 text-muted-foreground hover:text-foreground transition-colors text-xs font-medium uppercase tracking-widest"
      >
        <ArrowLeft size={14} />
        Back to Dashboard
      </button>

      <Card className="w-full max-w-md bg-black/40 border-border backdrop-blur-xl relative z-10">
        <CardHeader className="text-center">
          <div className="mx-auto w-12 h-12 rounded-full bg-emerald-500/10 flex items-center justify-center mb-4">
            <AlertCircle className="text-emerald-500" size={24} />
          </div>
          <CardTitle className="text-foreground font-display text-2xl tracking-tight">Sentry Verification</CardTitle>
          <CardDescription className="text-muted-foreground text-xs uppercase font-medium tracking-[0.2em] mt-1">
            Testing Error Tracking & PII Collection
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col gap-4">
          <p className="text-muted-foreground text-sm text-center mb-4">
            Click the button below to trigger an intentional error. This will test your Sentry integration and verify that PII (like your IP address) is being collected.
          </p>
          
          <Button
            variant="destructive"
            className="w-full h-12 font-semibold uppercase tracking-widest bg-red-600 hover:bg-red-500 transition-all active:scale-[0.98]"
            onClick={async () => {
              console.log("[SentryTest] Triggering intentional error...");
              
              Sentry.captureException(new Error('This is your first error!'));
              
              await Sentry.flush(2000);
              console.log("[SentryTest] Sent to Sentry");
            }}
          >
            Break the world
          </Button>
          
          <div className="mt-4 p-4 rounded-lg bg-emerald-500/5 border border-emerald-500/10 text-[10px] text-emerald-400 font-mono">
            <p>// Sentry Config Status:</p>
            <p className="mt-1">DSN: Loaded</p>
            <p>PII: Enabled</p>
            <p>Replays: Active (10%)</p>
          </div>
        </CardContent>
      </Card>
      
      <p className="text-[10px] text-slate-700 font-semibold uppercase tracking-[0.4em]">
        DCODE Corporate Diagnostic Tool
      </p>
    </div>
  );
}
